
<script>
    import { selectedItem } from '../../../store/store.js';
</script>

<div class="key-value-table box">
    <h5>Styrning</h5>

    <h6 style="font-weight: 500;">Styrelsestruktur</h6>
    <h6>{$selectedItem?.governance?.board_structure?.number_of_members ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.governance?.board_structure?.supplementary_members ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Styrelsens ansvar</h6>
    <h6>{$selectedItem?.governance?.board_authorities ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Beslutsprocess</h6>
    <h6>{$selectedItem?.governance?.decision_making_process ?? "Uppgifter saknas"}</h6>
</div>